(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/store/tickets-einstant-context.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/store/tickets-einstant-context.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _React = React,
  createContext = _React.createContext,
  useReducer = _React.useReducer,
  useEffect = _React.useEffect;
const routerContext = createContext();
const actions = {
  GAME_URL: 'GAME_URL',
  UPDATE_CATEGORIES: 'UPDATE_CATEGORIES'
};
const reducer = function (state) {
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const GAME_URL = actions.GAME_URL,
    UPDATE_CATEGORIES = actions.UPDATE_CATEGORIES;
  const type = action.type,
    payload = action.payload;
  switch (type) {
    case GAME_URL:
      return _objectSpread(_objectSpread({}, state), {}, {
        gameUrl: payload.gameUrl
      });
    case UPDATE_CATEGORIES:
      return _objectSpread(_objectSpread({}, state), {}, {
        categories: payload.categories
      });
    default:
      return state;
  }
};
const createInitialState = match => {
  var _match$params;
  return {
    gameUrl: match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.gameId,
    baseUrl: window.location.pathname,
    categories: svs.eInstant.data.categories || []
  };
};
const RouterProvider = _ref => {
  let children = _ref.children;
  const infoMatch = svs.eInstant.util.infoPageMatch;
  const match = infoMatch();
  const _useReducer = useReducer(reducer, createInitialState(match)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(() => {
    window.addEventListener('popstate', () => {
      var _match$params2;
      const match = infoMatch();
      dispatch({
        type: actions.GAME_URL,
        payload: {
          gameUrl: match === null || match === void 0 || (_match$params2 = match.params) === null || _match$params2 === void 0 ? void 0 : _match$params2.gameId
        }
      });
    });
  }, []);
  return React.createElement(routerContext.Provider, {
    value: {
      dispatch,
      state
    }
  }, children);
};
setGlobal('svs.eInstant.store', {
  reducer,
  actions,
  RouterContext: routerContext,
  RouterProvider,
  createInitialState
});

 })(window);